import { render, staticRenderFns } from "./BasketDropDown.vue?vue&type=template&id=62c3c9c5&scoped=true&"
import script from "./BasketDropDown.vue?vue&type=script&lang=js&"
export * from "./BasketDropDown.vue?vue&type=script&lang=js&"
import style0 from "./BasketDropDown.scss?vue&type=style&index=0&id=62c3c9c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3c9c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
